import { useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "sonner";
import { API } from "@/lib/content";

const input = "mt-1 block w-full bg-transparent border-b border-pine/40 py-2 text-base focus:outline-none focus:border-brass transition-colors";

export const BookingForm = ({ day, time, onBooked }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", format: "phone", note: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/bookings`, {
        ...form,
        phone: form.phone || null,
        note: form.note || null,
        date: format(day, "yyyy-MM-dd"),
        time,
      });
      toast.success("Your time is booked.");
      onBooked(data);
    } catch (err) {
      toast.error(err.response?.data?.detail && typeof err.response.data.detail === "string"
        ? err.response.data.detail
        : "Please check your details and try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-6 grid gap-4" data-testid="booking-form">
      <p className="lb text-brass-ink">3 · Your details</p>
      <label className="text-sm">Name<input required value={form.name} onChange={set("name")} className={input} data-testid="booking-name-input" /></label>
      <label className="text-sm">Email<input required type="email" value={form.email} onChange={set("email")} className={input} data-testid="booking-email-input" /></label>
      <label className="text-sm">Phone (optional)<input type="tel" value={form.phone} onChange={set("phone")} className={input} data-testid="booking-phone-input" /></label>
      <div className="flex gap-3" role="radiogroup" aria-label="Session format">
        {["phone", "video"].map((f) => (
          <button
            key={f}
            type="button"
            role="radio"
            aria-checked={form.format === f}
            onClick={() => setForm({ ...form, format: f })}
            className={`flex-1 rounded-full border py-2 capitalize transition-colors ${form.format === f ? "border-pine bg-pine text-sage" : "border-pine/30 hover:border-brass"}`}
            data-testid={`booking-format-${f}`}
          >
            {f}
          </button>
        ))}
      </div>
      <label className="text-sm">Anything you'd like us to know? (optional)<textarea rows="2" value={form.note} onChange={set("note")} className={input} data-testid="booking-note-input" /></label>
      <button type="submit" disabled={saving} className="mt-2 block text-center bg-pine text-sage rounded-full py-4 transition-colors hover:bg-pine-soft disabled:opacity-70" data-testid="booking-submit-button">
        {saving ? "Booking..." : `Book ${format(day, "EEE, MMM d")} · ${time}`}
      </button>
    </form>
  );
};
